export default __webpack_public_path__ + "9b66a0d75bfbcdbea4088e36c6fb0b9c.png";